import React from 'react';
import ReactSwitch from 'react-switch';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';

const DELIVERY_DAY_OPTIONS = ['Sunday', 'Monday', 'Saturday'];

function PublishOptionCard({ selected, onSelect, label, description }) {
  return (
    <div
      className={`publish-option-card ${selected ? 'is-selected' : ''}`}
      onClick={onSelect}
    >
      <div
        className={`publish-option-radio ${selected ? 'is-selected' : ''}`}
      />
      <div>
        <div className="publish-option-label">{label}</div>
        <div className="publish-option-desc">{description}</div>
      </div>
    </div>
  );
}

function PreferenceRow({ label, description, children }) {
  return (
    <div className="syllabus-preference-row">
      <div>
        <div className="syllabus-preference-label">{label}</div>
        {description && (
          <div className="syllabus-preference-description">{description}</div>
        )}
      </div>
      <div className="syllabus-preference-control">{children}</div>
    </div>
  );
}

function ToggleField({ checked, onChange }) {
  return (
    <div className="syllabus-toggle-wrap">
      <ReactSwitch
        offColor="#d7dee6"
        offHandleColor="#ffffff"
        onColor="#1a73e8"
        onHandleColor="#ffffff"
        handleDiameter={16}
        width={38}
        height={22}
        borderRadius={22}
        boxShadow="0 1px 3px rgba(16, 24, 40, 0.18)"
        activeBoxShadow="0 0 0 3px rgba(26, 115, 232, 0.15)"
        checkedIcon={false}
        uncheckedIcon={false}
        checked={checked}
        onChange={onChange}
      />
    </div>
  );
}

export default function SyllabusUploadStepPublishArticles({
  value,
  onChange,
  onBack,
  onConfirm,
  loading,
}) {
  const updateValue = (key, val) => onChange({ ...value, [key]: val });
  const autoPublish = value.autoPublishWithoutReview;

  return (
    <div className="syllabus-step">
      <div className="main-con">
        <div className="modal-header">
          <div className="syllabus-step-title">
            Do you want to review the articles before students see them?
          </div>
          {/* <p className="syllabus-step-desc mt-1">
            You can change this at any time.
          </p> */}
        </div>
        <div className="section-con">
          <PublishOptionCard
            selected={!autoPublish}
            onSelect={() => updateValue('autoPublishWithoutReview', false)}
            label="Yes, I’ll review articles first."
            description="Each week you get an email to approve or remove suggested articles before students see them."
          />
          <PublishOptionCard
            selected={autoPublish}
            onSelect={() => updateValue('autoPublishWithoutReview', true)}
            label="No, auto-publish to students."
            description="Suggested articles go live automatically each week. You can still edit them any time."
          />
          {/* {!autoPublish && (
            <div className="publish-delivery-options">
              <PreferenceRow
                label="Delivery day"
                description="When we send suggested articles for your review"
              >
                <select
                  className="syllabus-preference-select"
                  value={value.deliveryDay}
                  onChange={(e) => updateValue('deliveryDay', e.target.value)}
                >
                  {DELIVERY_DAY_OPTIONS.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </PreferenceRow>
              <PreferenceRow
                label="Reminder if not reviewed by Tuesday"
                description="We'll nudge you if you haven't reviewed that week's articles"
              >
                <ToggleField
                  checked={value.reminderIfNotReviewed}
                  onChange={(checked) =>
                    updateValue('reminderIfNotReviewed', checked)
                  }
                />
              </PreferenceRow>
              <PreferenceRow
                label="Show instructor notes to students"
                description="Students can see notes you add alongside articles"
              >
                <ToggleField
                  checked={value.showInstructorNotes}
                  onChange={(checked) =>
                    updateValue('showInstructorNotes', checked)
                  }
                />
              </PreferenceRow>
            </div>
          )} */}
        </div>
        <div className="syllabus-step-footer">
          <div />
          <div className="d-flex align-items-center" style={{ gap: '1rem' }}>
            <RectangularButton onClick={onBack} disabled={loading}>
              Back
            </RectangularButton>
            <RectangularButton
              darkButton
              onClick={onConfirm}
              disabled={loading}
            >
              Continue
            </RectangularButton>
          </div>
        </div>
      </div>
    </div>
  );
}
